var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6667 11.9154H23.8333C23.8333 6.35792 19.6376 2.1665 14.0725 2.1665V4.33317C18.473 4.33317 21.6667 7.52142 21.6667 11.9154Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0834 8.6666C16.3616 8.6666 17.3334 9.63835 17.3334 11.9166H19.5001C19.5001 8.42285 17.5771 6.49993 14.0834 6.49993V8.6666ZM17.7906 14.5632C17.5824 14.374 17.3089 14.2731 17.0277 14.2818C16.7465 14.2905 16.4797 14.4081 16.2836 14.6098L13.6912 17.2758C13.0672 17.1567 11.8127 16.7656 10.5214 15.4775C9.23006 14.1851 8.83898 12.9274 8.72306 12.3077L11.387 9.71418C11.5889 9.51824 11.7067 9.25141 11.7154 8.97016C11.7241 8.68891 11.623 8.41531 11.4336 8.20727L7.43064 3.80568C7.24111 3.59699 6.97768 3.4704 6.69631 3.4528C6.41494 3.4352 6.13779 3.52798 5.92373 3.71143L3.57289 5.72752C3.3856 5.91549 3.27381 6.16567 3.25873 6.4306C3.24248 6.70143 2.93264 13.1169 7.90731 18.0938C12.2471 22.4325 17.6833 22.7499 19.1805 22.7499C19.3993 22.7499 19.5336 22.7434 19.5694 22.7413C19.8343 22.7264 20.0843 22.6141 20.2714 22.426L22.2864 20.0741C22.47 19.8602 22.5629 19.5831 22.5456 19.3017C22.5282 19.0204 22.4018 18.7569 22.1932 18.5672L17.7906 14.5632Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/Phone.94583a99a7a7e40d9604da50bbed8ed3.svg";
export { ForwardRef as ReactComponent };